var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M6,13.223,8.45,16.7a1.049,1.049,0,0,0,1.707.051L18,6.828","key":1}),React.createElement("circle",{"className":"a","cx":"12","cy":"11.999","r":"11.25","key":2})]);
}

CheckCircle.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/check-circle.svg
// module id = 1061
// module chunks = 0